import { render, staticRenderFns } from "./PartsLayout.vue?vue&type=template&id=9f299134"
import script from "./PartsLayout.vue?vue&type=script&lang=ts"
export * from "./PartsLayout.vue?vue&type=script&lang=ts"
import style0 from "./PartsLayout.vue?vue&type=style&index=0&id=9f299134&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports